import React, { Component } from "react";
import styled, { withTheme } from "styled-components";
import { connect } from "react-redux";
import { MySnackbarContentWrapper } from './MySnackbarContentWrapper';
import Alert from '@material-ui/lab/Alert';

import {
  Grid,
  Hidden,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar as MuiToolbar,
  Snackbar,
  Typography
} from "@material-ui/core";
import LocalStorageService from "./../services/LocalStorageService";

import { Menu as MenuIcon } from "@material-ui/icons";

import UserMenu from "./UserMenu";
import { listOrder } from "../models/order";
import { listCustomer } from "../models/customer";
import NumberFormat from "react-number-format";
import { TOPUP_LOW_BALANCE } from "../utills/constant";

const localStorageService = LocalStorageService.getService();

const AppBar = styled(MuiAppBar)`
  background: ${props => props.theme.header.background};
  color: ${props => props.theme.header.color};
  box-shadow: ${props => props.theme.shadows[1]};
`;

const Toolbar = styled(MuiToolbar)`
  background-color: #FFF;
  box-shadow: 0 0 14px 0 rgba(53,64,82,.05);
`;
const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Breadcrumb = styled.div`
  background-color: ${props => props.theme.header.background};
  display: none;
  position: relative;
  width: 100%;
  ${props => props.theme.breakpoints.up("md")} {
    display: block;
  }
  font-weight: bold;
  color: #606673;
`;

const User = styled.div`
  background-color: ${props => props.theme.header.background};
  display: none;
  position: relative;
  width: 100%;
  ${props => props.theme.breakpoints.up("md")} {
    display: block;
  }
  font-weight: bold;
  color: #606673;
`;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { userName: '', roleName: '', countOrder: 0, isOpen: true, isClose: false, topupBalance: null };
  }

  async componentWillMount() {
    this.getOrder();
    await setInterval(this.getOrder, 300000);
  }

  componentDidMount() {
    let userInfor = JSON.parse(localStorageService.getUserInfor());
    if (userInfor) {
      this.setState({ userName: userInfor.fullName, roleName: userInfor.roleName })
    }
    let isClose = localStorageService.getCloseNotification();
    this.setState({ isClose: isClose });
    this.getTopupBalance();
    // NewOrder fires this after a successful booking, which may have deducted
    // from the balance
    window.addEventListener('topup-refresh', this.getTopupBalance);
  }

  componentWillUnmount() {
    window.removeEventListener('topup-refresh', this.getTopupBalance);
  }

  // TOP UP is the prepaid balance drawn down by ePacket bookings. The customer
  // profile is keyed by user id here, matching how the order pages look it up.
  getTopupBalance = () => {
    let userInfor = JSON.parse(localStorageService.getUserInfor());
    if (!userInfor || !userInfor.id) {
      return;
    }
    listCustomer({ customer_id: userInfor.id }).then((res) => {
      let customer = res && res.customer ? res.customer[0] : null;
      // only customers staff have put on the prepaid wallet see a TOP UP box;
      // for everyone else it stays hidden and nothing about their flow changes
      if (customer && customer.topup_enabled == 1) {
        this.setState({ topupBalance: customer.topup_balance ? customer.topup_balance : 0 });
      } else {
        this.setState({ topupBalance: null });
      }
    }).catch(() => { });
  }

  getOrder = () => {
    let params = {
      count_order: 1,
      status: 11
    };
    listOrder(params).then((res) => {
      this.setState({ countOrder: res ? res.count : 0 });
    });
  }

  handleClose = e => {
    localStorageService.setCloseNotification(true);
    let isClose = localStorageService.getCloseNotification();
    this.setState({ isClose: isClose });
  }

  render() {
    let { onDrawerToggle } = this.props;
    let { userName, roleName, isOpen, countOrder, isClose, topupBalance } = this.state;
    let userInfor = JSON.parse(localStorageService.getUserInfor());
    return (
      <React.Fragment>
        <AppBar position="sticky" elevation={0}>
          <Toolbar >
            <Grid container alignItems="center">
              <Hidden mdUp>
                <Grid item>
                  <IconButton
                    // color="inherit"
                    aria-label="Open drawer"
                    onClick={onDrawerToggle}
                  >
                    <MenuIcon />
                  </IconButton>
                </Grid>
              </Hidden>
              <Grid item>
                <Breadcrumb>
                  {/* {breadcrumb} */}
                </Breadcrumb>
              </Grid>
                <Grid item xs style={{ textAlign: "left", maxWidth: 300 }}>
                  {userInfor.type !== "international" && (
                    <Alert onClose={e => this.handleClose(e)} variant="filled" severity="warning" style={{ display: isClose != 'false' ? 'none' : '' }}>
                      <Typography style={{ fontSize: 10 }}>Bạn có {countOrder} đơn hàng cần duyệt hoàn</Typography>
                    </Alert>
                  )}
                  {topupBalance !== null && (
                    <div style={{
                      display: "inline-block",
                      border: "1px solid #e0e0e0",
                      borderRadius: 4,
                      padding: "4px 12px",
                      backgroundColor: "#fafafa"
                    }}>
                      <Typography style={{ fontSize: 11, color: "#606673", lineHeight: 1.2 }}>TOP UP</Typography>
                      <Typography style={{
                        fontSize: 18,
                        fontWeight: "bold",
                        lineHeight: 1.2,
                        // red once it is running low, which includes owing us
                        color: parseFloat(topupBalance || 0) < TOPUP_LOW_BALANCE ? "#b71c1c" : "#1b5e20"
                      }}>
                        <NumberFormat
                          value={topupBalance}
                          displayType="text"
                          thousandSeparator
                          suffix=" đ"
                        />
                      </Typography>
                      {parseFloat(topupBalance || 0) < TOPUP_LOW_BALANCE && (
                        <Typography style={{ fontSize: 10, color: "#b71c1c", lineHeight: 1.2 }}>
                          Số dư sắp hết, vui lòng nạp thêm
                        </Typography>
                      )}
                    </div>
                  )}
              </Grid>
              <Grid item xs style={{ textAlign: "center" }}>
                <h2 style={{ color: "#212121" }}> QUẢN LÝ ĐƠN HÀNG </h2>
              </Grid>
              {/* <Grid item xs /> */}
              <Grid item style={{ textAlign: "right", paddingRight: '20px' }}>
                <User>
                  {userName}
                  <UserMenu />
                </User>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </React.Fragment >
    );
  }
}

const mapStateToProps = (store) => {
  return {
    breadcrumb: store.breadcrumbReducer.currentBreadcrumb
  }
};

const mapDispatchToProps = (dispatch, props) => {
  return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(Header));

